import { VERSIONS_TABLE_SESSIONS_SIZES } from "@pages/analytics/constants";

export const VersionTableSessionRowSkeleton = () => {
  return (
    <div className="tw-flex tw-items-center tw-bg-[#F9F9FA] tw-border-b tw-border-solid tw-border-blue-100 tw-py-0.5 tw-min-h-[53px] last:tw-border-b-0">
      {/* Reader column */}
      <div className="tw-flex-auto tw-px-2 tw-pl-11 tw-py-2 tw-flex tw-items-center tw-min-w-0">
        <div className="tw-pl-2 tw-flex tw-flex-col tw-gap-2 tw-justify-center tw-min-w-0 tw-w-full">
          <div className="tw-flex tw-items-center tw-gap-1.5 tw-min-w-0">
            <span className="tw-block tw-h-1.5 tw-w-24 tw-rounded-lg tw-bg-blue-100/50 tw-animate-skeleton-loading"></span>
            <span className="tw-block tw-h-1.5 tw-w-16 tw-rounded-full tw-bg-blue-100/50 tw-animate-skeleton-loading tw-flex-shrink-0"></span>
          </div>
          <span className="tw-block tw-h-1.5 tw-w-40 tw-rounded-lg tw-bg-blue-100/50 tw-animate-skeleton-loading"></span>
        </div>
      </div>

      {/* Session started column */}
      <div
        className="tw-px-2 tw-flex tw-items-center tw-h-[53px]"
        style={{ width: VERSIONS_TABLE_SESSIONS_SIZES.SESSION_STARTED }}
      >
        <span className="tw-block tw-h-1.5 tw-w-20 tw-rounded-lg tw-bg-blue-100/50 tw-animate-skeleton-loading"></span>
      </div>

      {/* Reading time column */}
      <div
        className="tw-px-2 tw-flex tw-items-center tw-h-[53px]"
        style={{ width: VERSIONS_TABLE_SESSIONS_SIZES.READING_TIME }}
      >
        <span className="tw-block tw-h-1.5 tw-w-10 tw-rounded-lg tw-bg-blue-100/50 tw-animate-skeleton-loading"></span>
      </div>

      {/* Clicked CTA column */}
      <div
        className="tw-px-2 tw-flex tw-items-center tw-h-[53px]"
        style={{ width: VERSIONS_TABLE_SESSIONS_SIZES.CLICKED_CTA }}
      >
        <span className="tw-size-6 tw-block tw-rounded tw-bg-blue-100/50 tw-animate-skeleton-loading"></span>
      </div>

      {/* Progress column */}
      <div
        className="tw-px-2 tw-flex tw-items-center tw-h-[53px]"
        style={{ width: VERSIONS_TABLE_SESSIONS_SIZES.PROGRESS }}
      >
        <div className="tw-flex tw-items-center tw-gap-2">
          <span className="tw-size-6 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-blue-100/50 tw-animate-skeleton-loading tw-flex-shrink-0">
            <span className="tw-size-4 tw-block tw-rounded-full tw-bg-[#F9F9FA]"></span>
          </span>
          <span className="tw-block tw-h-1.5 tw-w-16 tw-rounded-lg tw-bg-blue-100/50 tw-animate-skeleton-loading"></span>
        </div>
      </div>

      {/* Location column */}
      <div
        className="tw-px-2 tw-flex tw-items-center tw-h-[53px]"
        style={{ width: VERSIONS_TABLE_SESSIONS_SIZES.LOCATION }}
      >
        <span className="tw-block tw-h-1.5 tw-w-24 tw-rounded-lg tw-bg-blue-100/50 tw-animate-skeleton-loading"></span>
      </div>

      {/* Device column with menu */}
      <div
        className="tw-px-2 tw-flex tw-items-center tw-justify-between tw-h-[53px]"
        style={{ width: VERSIONS_TABLE_SESSIONS_SIZES.DEVICE }}
      >
        <div className="tw-flex tw-items-center tw-gap-2.5 tw-min-w-0">
          <span className="tw-size-3.5 tw-block tw-rounded tw-bg-blue-100/50 tw-animate-skeleton-loading tw-flex-shrink-0"></span>
          <span className="tw-block tw-h-1.5 tw-w-12 tw-rounded-lg tw-bg-blue-100/50 tw-animate-skeleton-loading"></span>
        </div>
      </div>
    </div>
  );
};
